import React from 'react';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { useModalActions } from '../../../../hooks';
export const MobileActionButtons = () => {
  const {
    t
  } = useTranslation(['home']);
  const {
    handleClickEnterWithCode,
    handleClickCreateSpace
  } = useModalActions();
  return <>
      <Button size="lg" leftSlot={<img src="/images/light/spaceMe/enter_space_primary.svg" alt="empty icon" />} isFullWidth variant="secondary" onClick={handleClickEnterWithCode} data-sentry-element="Button" data-sentry-source-file="MobileActionButtons.tsx">
        {t('home:space_me_enter_with_code')}
      </Button>
      <Button size="lg" leftSlot={<img src="/images/light/spaceMe/plus_white_sm.svg" alt="empty icon" />} isFullWidth variant="primary" onClick={handleClickCreateSpace} data-sentry-element="Button" data-sentry-source-file="MobileActionButtons.tsx">
        {t('home:space_me_create_space_button')}
      </Button>
    </>;
};